import React from "react";
import { IconSecure } from "../icons";
import Button from "../form/Button";

interface Props {
	ctaLabel?: string;
	onCtaClick?: () => void;
	children?: React.ReactNode;
}

const CorePanelFooter: React.FC<Props> = ({
	ctaLabel = "Cancel",
	onCtaClick,
	children,
}) => {
	return (
		<div className="absolute bottom-0 h-min w-full p-4 sm:p-5 bottom-0 left-0 right-0 rounded-[5px] outline outline-1 outline-offset-[-1px] outline-neutral-200 flex flex-col sm:flex-col justify-between items-start sm:items-center gap-4 sm:gap-5">
			<div className="flex items-start gap-2 w-full sm:w-auto">
				<div className="inline-flex flex-col justify-start items-start gap-2.5 text-green-500">
					<IconSecure />
				</div>
				<div className="flex-1 inline-flex flex-col justify-start items-start">
					<div className="justify-start text-green-500 text-xs font-semibold font-['Inter']">
						Secure Data Transfer
					</div>
					<div className="justify-start font-light text-black text-[10px] font-normal font-['Inter'] leading-[13px] max-w-[240px] sm:max-w-none">
						King Energy does not store or share your PG&E password
						with anyone.
					</div>
				</div>
			</div>
			{children && <div className="flex flex-row gap-2 w-full">{children}</div>}
		</div>
	);
};

export default CorePanelFooter;
